import { createReduxModule } from '@skippay/core/utils/reduxUtils';

import { MODULE_NAME } from './constants';
import reducer from './reducer';

export * from './actions';
export * from './selectors';

export default createReduxModule(MODULE_NAME, reducer);
